// Seed data — demo vehicles/projects for local dev and empty-DB fallback.
// Generic examples only. Real user data lives in D1.

export const SEED_VEHICLES = [
  {
    id: "demo-sedan",
    year: 2015,
    make: "Honda",
    model: "Civic",
    color: "#3b82f6",
    bolt_pattern: "5x114.3",
    obd_protocol: "CAN 11-bit 500k",
    icon: "🔵",
    notes: "",
    projects: [
      {
        id: "demo-brakes",
        vehicle_id: "demo-sedan",
        title: "Front Brake Pad Replacement",
        status: "active",
        created_at: "2026-01-15",
        updated_at: "2026-01-15",
        module: "repair",
        fsmSections: ["Brake System"],
        notes: "",
        steps: [
          { text: "Loosen lug nuts, raise vehicle, remove wheel", done: false },
          { text: "Remove caliper bolts and hang caliper with wire", done: false },
          { text: "Remove old pads, compress piston", done: false },
          { text: "Install new pads, reinstall caliper", done: false },
          { text: "Reinstall wheel, torque lug nuts to spec", done: false },
          { text: "Pump brake pedal to seat pads, test drive", done: false },
        ],
        parts: [{ name: "Front brake pads", status: "on-hand" }],
        tools: [
          { name: "Floor jack and stands", have: true },
          { name: "Breaker bar", have: true },
          { name: "Caliper piston compressor", have: false },
          { name: "Torque wrench", have: true },
        ],
      },
    ],
  },
  {
    id: "demo-truck",
    year: 2008,
    make: "Toyota",
    model: "Tacoma",
    color: "#ef4444",
    bolt_pattern: "6x139.7",
    obd_protocol: "CAN 11-bit 500k",
    icon: "🔴",
    notes: "",
    projects: [
      {
        id: "demo-nostart",
        vehicle_id: "demo-truck",
        title: "No-Start Diagnosis",
        status: "active",
        created_at: "2026-03-01",
        module: "diagnostics",
        fsmSections: ["Starting System", "Fuel System"],
        notes: "",
        steps: [
          { text: "Turn key to ON — listen for fuel pump prime", done: false },
          { text: "Check fuel pump relay and fuse", done: false },
          { text: "Test power at fuel pump connector", done: false },
          { text: "Check for spark at plugs", done: false },
          { text: "Verify crank position sensor signal", done: false },
        ],
        parts: [],
        tools: [
          { name: "Multimeter", have: true },
          { name: "Test light", have: true },
          { name: "Spark tester", have: false },
        ],
        troubleshooting: {
          symptom: "Engine cranks but will not start",
          known: [
            { fact: "Engine cranks at normal speed", eliminates: "Starter / battery / ignition switch" },
          ],
          currentStep: 0,
          steps: [
            {
              id: "listen-fuel-pump",
              instruction: "Turn key to ON (not start) — listen for fuel pump prime",
              detail: "With the key in ON position, you should hear a brief hum from the fuel tank area. No sound means the pump isn't running.",
              fsmRef: "Fuel System",
              expect: "Brief hum from rear of vehicle",
              testType: "pass_fail",
              result: null, testedAt: null, note: "",
            },
            {
              id: "check-relay",
              instruction: "Locate and test fuel pump relay",
              detail: "Check the relay panel. Swap with an identical relay from another position and re-test.",
              fsmRef: "Fuel System",
              expect: "Fuel pump primes with swapped relay",
              testType: "choice",
              choices: [
                { label: "Pump primes with swapped relay", next: "confirm-relay-fix", color: "#4ade80" },
                { label: "Still no prime", next: "check-fuse", color: "#f87171" },
              ],
              result: null, testedAt: null, note: "",
            },
            {
              id: "confirm-relay-fix",
              instruction: "Replace relay — that was the problem",
              detail: "Order the correct replacement relay.",
              fsmRef: "Fuel System",
              expect: "Vehicle starts",
              testType: "pass_fail",
              result: null, testedAt: null, note: "",
            },
            {
              id: "check-fuse",
              instruction: "Check fuel pump fuse",
              detail: "Pull and inspect, or test continuity.",
              fsmRef: "Fuel System",
              expect: "Fuse intact",
              testType: "pass_fail",
              result: null, testedAt: null, note: "",
            },
            {
              id: "check-spark",
              instruction: "Check for spark at plugs",
              detail: "Use an inline spark tester. Crank the engine and look for a bright spark.",
              fsmRef: "Ignition System",
              expect: "Strong blue/white spark visible",
              testType: "pass_fail",
              result: null, testedAt: null, note: "",
            },
            {
              id: "check-fuel-pressure",
              instruction: "Check fuel pressure at rail",
              detail: "Connect a fuel pressure gauge to the test port on the fuel rail.",
              fsmRef: "Fuel System",
              expect: "Pressure within manufacturer spec",
              testType: "measurement",
              unit: "PSI",
              specMin: 40, specMax: 60,
              result: null, testedAt: null, note: "",
            },
          ],
        },
      },
    ],
  },
];
